import { graphql } from './generated/gql'

export const CLOUD_AGENT_DEFINITIONS_QUERY = graphql(`
  query CloudAgentDefinitions {
    pantheon {
      cloudAgent {
        definitions {
          id
          name
          prompt
          model
          createdAt
          updatedAt
        }
      }
    }
  }
`)

export const CLOUD_AGENT_RUNS_QUERY = graphql(`
  query CloudAgentRuns($definitionId: ID!) {
    pantheon {
      cloudAgent {
        runs(definitionId: $definitionId) {
          id
          prompt
          status
          keepOpen
          createdAt
          updatedAt
        }
      }
    }
  }
`)

export const CLOUD_AGENT_RUN_DETAILS_QUERY = graphql(`
  query CloudAgentRunDetails($runId: ID!, $after: ID, $accessAfter: ID) {
    pantheon {
      cloudAgent {
        run(id: $runId) {
          id
          status
          keepOpen
          steeringReceipts {
            id
            sequence
            message
            actorIdentityArn
            acceptedAt
            state
            appliedAt
          }
          logs(after: $after) {
            id
            eventType
            level
            message
            createdAt
            updatedAt
          }
          access(after: $accessAfter) {
            id
            createdAt
            ... on pantheon_CloudAgentS3AccessEvent {
              method
              path
            }
            ... on pantheon_CloudAgentModelAccessEvent {
              invocationId
              model
              inputTokens
              cacheCreationInputTokens
              cacheReadInputTokens
              outputTokens
              costMicroUsd
              durationMs
            }
          }
          modelUsage {
            id
            createdAt
            model
            invocationCount
            inputTokens
            cacheCreationInputTokens
            cacheReadInputTokens
            outputTokens
            costMicroUsd
            durationMs
          }
        }
      }
    }
  }
`)

export const CLOUD_AGENT_ARTIFACTS_QUERY = graphql(`
  query CloudAgentArtifacts($runId: ID!) {
    pantheon {
      cloudAgent {
        artifacts(runId: $runId) {
          id
          name
          job
          organisationId
          createdAt
          updatedAt
          latestVersion {
            id
            version
            contentType
            byteSize
            createdAt
            updatedAt
          }
          versions {
            id
            version
            contentType
            byteSize
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`)

export const CLOUD_AGENT_ARTIFACT_CONTENT_QUERY = graphql(`
  query CloudAgentArtifactContent($runId: ID!) {
    pantheon {
      cloudAgent {
        artifacts(runId: $runId) {
          id
          latestVersion {
            id
            blob
          }
        }
      }
    }
  }
`)

export const CREATE_CLOUD_AGENT_DEFINITION_MUTATION = graphql(`
  mutation CreateCloudAgentDefinition($name: String!, $prompt: String!, $model: String) {
    pantheon {
      cloudAgent {
        createDefinition(name: $name, prompt: $prompt, model: $model) {
          id
          name
          prompt
          model
          createdAt
          updatedAt
        }
      }
    }
  }
`)

export const UPDATE_CLOUD_AGENT_DEFINITION_PROMPT_MUTATION = graphql(`
  mutation UpdateCloudAgentDefinitionPrompt($id: ID!, $prompt: String!) {
    pantheon {
      cloudAgent {
        updateDefinitionPrompt(id: $id, prompt: $prompt) {
          id
          name
          prompt
          model
          createdAt
          updatedAt
        }
      }
    }
  }
`)

export const UPDATE_CLOUD_AGENT_DEFINITION_NAME_MUTATION = graphql(`
  mutation UpdateCloudAgentDefinitionName($id: ID!, $name: String!) {
    pantheon {
      cloudAgent {
        updateDefinitionName(id: $id, name: $name) {
          id
          name
          prompt
          model
          createdAt
          updatedAt
        }
      }
    }
  }
`)

export const UPDATE_CLOUD_AGENT_DEFINITION_MODEL_MUTATION = graphql(`
  mutation UpdateCloudAgentDefinitionModel($id: ID!, $model: String!) {
    pantheon {
      cloudAgent {
        updateDefinitionModel(id: $id, model: $model) {
          id
          name
          prompt
          model
          createdAt
          updatedAt
        }
      }
    }
  }
`)

export const RUN_CLOUD_AGENT_DEFINITION_MUTATION = graphql(`
  mutation RunCloudAgentDefinition($definitionId: ID!, $keepOpen: Boolean) {
    pantheon {
      cloudAgent {
        runDefinition(definitionId: $definitionId, keepOpen: $keepOpen) {
          id
          prompt
          status
          keepOpen
          createdAt
          updatedAt
        }
      }
    }
  }
`)

export const STOP_CLOUD_AGENT_RUN_MUTATION = graphql(`
  mutation StopCloudAgentRun($id: ID!) {
    pantheon {
      cloudAgent {
        stopRun(id: $id) {
          id
          status
          updatedAt
        }
      }
    }
  }
`)

export const STEER_CLOUD_AGENT_RUN_MUTATION = graphql(`
  mutation SteerCloudAgentRun($id: ID!, $message: String!) {
    pantheon {
      cloudAgent {
        steerRun(id: $id, message: $message) {
          id
          sequence
          message
          actorIdentityArn
          acceptedAt
          state
          appliedAt
        }
      }
    }
  }
`)

export const DELETE_CLOUD_AGENT_RUN_MUTATION = graphql(`
  mutation DeleteCloudAgentRun($id: ID!) {
    pantheon {
      cloudAgent {
        deleteRun(id: $id)
      }
    }
  }
`)

export const DELETE_CLOUD_AGENT_DEFINITION_MUTATION = graphql(`
  mutation DeleteCloudAgentDefinition($id: ID!) {
    pantheon {
      cloudAgent {
        deleteDefinition(id: $id)
      }
    }
  }
`)

export const ORGANISATIONS_QUERY = graphql(`
  query ConsoleOrganisations {
    organization {
      getOrganizations { id name subdomain cloud region }
    }
  }
`)
export const CHAT_USERS_QUERY = graphql(`
  query ConsoleChatUsers($organisationId: ID!, $month: String!) {
    pantheon {
      chatUsers(organisationId: $organisationId, month: $month) {
        organisationId userGlobalId month costUsd monthlyBudgetUsd
      }
    }
  }
`)
export const SET_BUDGET_MUTATION = graphql(`
  mutation ConsoleSetBudget($organisationId: ID!, $userGlobalId: ID!, $monthlyBudgetUsd: Float) {
    pantheon {
      setChatUserBudget(organisationId: $organisationId, userGlobalId: $userGlobalId, monthlyBudgetUsd: $monthlyBudgetUsd) {
        organisationId userGlobalId month costUsd monthlyBudgetUsd
      }
    }
  }
`)
